import { Button, Dialog, DialogContent } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { isArrayNullOrEmpty } from "../../helper/helper";
import { PaymentModel, VirtualAccount } from "../../models/organisation/PaymentModel";
import { colorPrimary } from "../../rsc/colors/colors";
import { RenderBankLogo } from "./PaymentInformation";

type Props = {
    isOpen: boolean
    onClose: () => void
    payments: PaymentModel
}

export const ModalMyVA: React.FC<Props> = ({ onClose, isOpen, payments }) => {

    const [copiedId, setCopiedId] = useState<string | null>(null);

    const copyToClipboard = async (accountNumber: string, id: string) => {
        try {
            await navigator.clipboard.writeText(accountNumber);
            setCopiedId(id);
            setTimeout(() => setCopiedId(null), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (<Dialog open={isOpen} onClose={() => { onClose(); }} maxWidth="sm" fullWidth>
        <DialogContent className="pem-modal-content">
            <div className="pem-modal-inner">
                <h3 className="pem-modal-title">
                    {t('virtual_accounts')}
                </h3>

                <p className="pem-modal-subtitle">
                    {t('mill_payment_instruction')}
                </p>

                <div className="pem-bank-list">
                    {!isArrayNullOrEmpty(payments?.getActiveVirtualAccounts()) ? (
                        payments.getActiveVirtualAccounts().map((va: VirtualAccount) => (
                            <div
                                key={va.id}
                                className={`pem-bank-item`}
                                style={{
                                    '--color-primary': colorPrimary()
                                } as React.CSSProperties}
                            >
                                <RenderBankLogo bankNameOrAccount={va.getBankName(payments.paymentProviders)} size="large" paymentProviders={payments.paymentProviders} />

                                <div className="pem-bank-info">
                                    <div className="pem-bank-name">
                                        {va.provider_id}
                                    </div>
                                    <div className="pempem-flex-row gap5" style={{alignItems:'center'}}>
                                        <div className="pem-bank-type">
                                            {va.accountNumber}
                                        </div>
                                        <button
                                            onClick={() => copyToClipboard(va.accountNumber, va.id)}
                                            className={`pem-button-copy ${copiedId === va.id ? 'copied' : ''}`}
                                        >
                                            <span style={{
                                                fontSize: copiedId === va.id ? '10px' : '16px',
                                                color: copiedId === va.id ? '#4CAF50' : '#667eea',
                                                fontWeight: 'bold'
                                            }}>
                                                {copiedId === va.id ? 'Copied' : '⎘'}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="pem-empty-state">
                            {t('no_banks_available') || 'No banks available for VA creation'}
                        </div>
                    )}
                </div>

                <div className="pem-actions">
                    <Button
                        onClick={() => onClose()}
                        variant="contained"
                        style={{
                            backgroundColor: colorPrimary(),
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 12px rgba(0, 151, 167, 0.3)'
                        }}
                    >
                        {t('close')}
                    </Button>
                </div>
            </div>
        </DialogContent>
    </Dialog>)
}